import { render, staticRenderFns } from "./VueHeader.vue?vue&type=template&id=145c647e&"
import script from "./VueHeader.vue?vue&type=script&lang=js&"
export * from "./VueHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports